



























































import dayjs from "dayjs";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class LearningCalendarCCategoryList extends Vue {
  // カレンダーに表示するデータ
  @Prop()
  private calendarDate!: { date: string; count: number }[];

  // 色
  private rangeColor = ["#ebedf0", "#ebedf0", "#D0F0DC", "#A0E3B7", "#57C693", "#1D8455"];

  // カレンダーラベル情報
  private labels = {
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    days: ["月", "火", "水", "木", "金", "土", "日"],
    less: "小",
    more: "大",
  };

  // カウントの最大
  private max = 5;

  // 年間日数
  private DAYS_IN_ONE_YEAR = 365;

  // 一週間の日数
  private DAYS_IN_WEEK = 7;

  // 箱の余白
  private SQUARE_BORDER_SIZE = 10 / 5;

  // 1箱範囲の大きさ
  private SQUARE_SIZE = 10 + this.SQUARE_BORDER_SIZE;

  // 箱上余白の高さ
  private TOP_SECTION_HEIGHT = this.SQUARE_SIZE + this.SQUARE_SIZE / 2;

  // 箱下余白の高さ
  private BOTTOM_SECTION_HEIGHT = this.SQUARE_SIZE + this.SQUARE_SIZE / 2;

  // 箱左余白の幅
  private LEFT_SECTION_WIDTH = Math.ceil(this.SQUARE_SIZE * 2.5);

  private width() {
    return this.LEFT_SECTION_WIDTH + this.SQUARE_SIZE * this.weekCount() + this.SQUARE_BORDER_SIZE;
  }

  private height =
    this.TOP_SECTION_HEIGHT +
    this.SQUARE_SIZE * this.DAYS_IN_WEEK +
    this.SQUARE_BORDER_SIZE +
    this.BOTTOM_SECTION_HEIGHT;

  // 週の数
  private weekCount() {
    return this.getDaysCount() / this.DAYS_IN_WEEK;
  }

  // 日数調整
  private _shiftDate(date: Date, numDays: number) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + numDays);
    return newDate;
  }

  // カレンダー表示情報
  private calendar() {
    const startDate = this._shiftDate(this.startDate, -this.getCountEmptyDaysAtStart()); // 月曜スタートの日付に変更

    return Array.from({ length: this.weekCount() }, () =>
      Array.from({ length: this.DAYS_IN_WEEK }, () => {
        const dDate = dayjs(startDate).format("YYYY-MM-DD"); // yyyy-mm-dd形式に変換
        const dayValues = this.activities()[dDate];
        startDate.setDate(startDate.getDate() + 1); // 一日進める
        return {
          date: dDate,
          count: dayValues ? dayValues.count : null,
          colorIndex: dayValues ? dayValues.colorIndex : 0,
        };
      })
    );
  }

  // countの表示濁を計算
  private getColorIndex(value: null | undefined | number) {
    if (value == null || value === undefined) {
      return 0;
    }
    if (value <= 0) {
      return 1;
    }
    if (value >= this.max) {
      return 5;
    }
    return Math.ceil(((value * 100) / this.max) * 0.03) + 1;
  }

  // 表示取得データのcountを加工
  private activities() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.calendarDate.reduce((newValues: any, day: { date: string; count: number }) => {
      const value = newValues;
      value[day.date] = {
        count: day.count,
        colorIndex: this.getColorIndex(day.count),
      };
      return value;
    }, {});
  }

  private monthsLabelWrapperTransform = `translate(${this.LEFT_SECTION_WIDTH}, 0)`;

  private daysLabelWrapperTransform = `translate(0, ${this.TOP_SECTION_HEIGHT - this.SQUARE_SIZE / 2})`;

  private legendWrapperTransform() {
    return `translate(${this.width() - this.SQUARE_SIZE * this.rangeColor.length - 30}, ${this.height -
      this.BOTTOM_SECTION_HEIGHT})`;
  }

  private yearWrapperTransform() {
    return `translate(${this.LEFT_SECTION_WIDTH}, ${this.TOP_SECTION_HEIGHT})`;
  }

  private viewbox() {
    return `0 0 ${this.width()} ${this.height}`;
  }

  private getMonthLabelPosition(month: { value: number; index: number }) {
    const position = { x: 0, y: 0 };
    position.x = this.SQUARE_SIZE * month.index;
    position.y = this.SQUARE_SIZE - this.SQUARE_BORDER_SIZE;
    return position;
  }

  private getDaysLabelPosition(index: number) {
    const position = { x: 0, y: 0 };
    position.y = this.SQUARE_SIZE * (index + 1) + this.SQUARE_BORDER_SIZE;
    return position;
  }

  private getWeekPosition(index: number) {
    return `translate(${index * this.SQUARE_SIZE}, 0)`;
  }

  private getDayPosition(index: number) {
    return `translate(0, ${index * this.SQUARE_SIZE})`;
  }

  // 今年最初の日
  private startDate = new Date(`${dayjs().year()}-01-01`);

  // 今年の1月分で一週間のマスの表示で足りない日数
  private getCountEmptyDaysAtStart() {
    return this.startDate.getDay() - 1;
  }

  // 今年最後の日
  private endDate = new Date(dayjs().year(), 12, 0);

  // 今年の12月分で一週間のマスの表示で足りない日数
  private getCountEmptyDaysAtEnd() {
    return this.DAYS_IN_WEEK - this.endDate.getDay();
  }

  // 一年間の日数
  private getDaysCount() {
    const year = dayjs().year();
    const days = this.DAYS_IN_ONE_YEAR + this.getCountEmptyDaysAtStart() + this.getCountEmptyDaysAtEnd();

    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return days + 1;
    }
    return days;
  }

  // 1日がある週のindexを返す
  private firstFullWeekOfMonths() {
    return this.calendar().reduce(
      (months: {}[], week: { date: string }[], index: number, weeks: { date: string }[][]) => {
        if (index > 0) {
          const lastWeek = dayjs(weeks[index - 1][0].date); // その週の最後の日
          const currentWeek = dayjs(week[0].date); // その週の最初の日
          if (lastWeek.year() < currentWeek.year() || lastWeek.month() < currentWeek.month()) {
            months.push({ value: currentWeek.month() + 1, index });
          }
        }
        return months;
      },
      []
    );
  }

  private limitCountRangeColor() {
    return this.rangeColor.slice(1, 6);
  }
}
